import { datadogRum } from '@datadog/browser-rum';
import { angularPlugin } from '@datadog/browser-rum-angular';
import { IAppConfig } from '../models/app-config';
import { buildRumInitConfig, shouldInitializeDatadogRum } from './datadog-rum.config';
import { datadogRumInitializedSignal } from './datadog-rum-state';

export interface BootstrapDatadogRumOptions {
  authConfig: IAppConfig;
  /** Uppercase environment name resolved by `main.ts` (`LOCAL`, `DEV`, `HML`, ...). */
  environmentName: string;
  hostname: string;
  version: string;
}

/**
 * Initializes the Datadog RUM SDK before Angular bootstraps when the runtime guards allow it.
 * Returns `false` and leaves `datadogRumInitializedSignal` at `false` when any guard fails,
 * which causes every `DatadogRumFacade` method to behave as a no-op.
 *
 * PENDING (Datadog onboarding): currently disabled in every environment until SRE provisions
 * the RUM Application (`applicationId`) and Client Token in the Datadog panel. To enable, flip
 * `environment.ts → flag[<ENV>][<COUNTRY>].datadog.enabled = true` and fill the IDs.
 */
export function bootstrapDatadogRum(options: BootstrapDatadogRumOptions): boolean {
  const { authConfig, environmentName, hostname, version } = options;

  if (!shouldInitializeDatadogRum(authConfig, hostname)) {
    return false;
  }

  const baseConfig = buildRumInitConfig({ authConfig, environmentName, version });

  datadogRum.init({
    ...baseConfig,
    plugins: [angularPlugin({ router: true })],
  });

  datadogRumInitializedSignal.set(true);
  return true;
}
